module.exports = __webpack_public_path__ + "img/20210129_141206.4cbc13ac.jpg";